import { Component, inject, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { SensorBlockDetailDto } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-sensor-block-delete-dialog',
  templateUrl: './sensor-block-delete-dialog.component.html',
  styleUrls: ['./sensor-block-delete-dialog.component.scss'],
})
export class SensorBlockDeleteDialogComponent {
  private readonly dialogRef = inject(NbDialogRef);

  @Input() sensorBlocks: SensorBlockDetailDto[] = [];

  get count(): number {
    return this.sensorBlocks.length;
  }

  get header(): string {
    return this.count === 1 ? 'Sensor-Block löschen' : `${this.count} Sensor-Blöcke löschen`;
  }

  get message(): string {
    return this.count === 1
      ? 'Möchten Sie den folgenden Sensor-Block wirklich löschen?'
      : `Möchten Sie die folgenden ${this.count} Sensor-Blöcke wirklich löschen?`;
  }

  onDelete(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
